// Libs
import ApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useMemo, useState } from "react";
// Types
import { ChartSetOne } from "../Libs/Types/ChartTypes";
// Utils
import {
  chartColors,
  CHART_AXIS_FALLBACK,
  humanize,
  chartHeight,
} from "../Libs/Utils/utils";
// UI-Components
import ChartFallBack from "../UI-Components/ChartFallback";

export default function LineChart({
  chartData,
  dataKey,
}: {
  chartData: ChartSetOne["LineChart"];
  dataKey: string;
}) {
  // Assign a unique color to this chart instance ONCE
  const [chartColor] = useState(() => chartColors);

  // If you have multi-series, you can generate a list of random colors ONCE per chart
  const colorList = useMemo(() => {
    if (!chartData?.yaxis) return [];
    return chartData.yaxis.map(() => chartColors);
  }, [chartData?.yaxis]);
  const fYData: object[] = [];
  if (chartData["ytitle"] !== undefined) {
    chartData["ytitle"]?.map((value, key) => {
      let temp = {};
      if (key === 1) {
        temp = {
          ...value,
          ...{
            opposite: true,
            labels: {
              style: {
                fontSize: "8px",
              },
              formatter: function (val: number) {
                if (typeof val === "number") {
                  return val.toFixed(0);
                } else {
                  return val;
                }
              },
            },
          },
        };
      } else {
        temp = {
          ...value,
          ...{
            labels: {
              style: {
                fontSize: "8px",
              },
              formatter: function (val: number) {
                if (typeof val === "number") {
                  return val.toFixed(0);
                } else {
                  return val;
                }
              },
            },
          },
        };
      }
      fYData.push(temp);
      return true;
    });
  }
  const option: ApexOptions = {
    chart: {
      fontFamily: "Poppins",
      toolbar: {
        show: true,
      },
    },
    title: {
      style: { fontSize: "14px", fontWeight: "900" },
      text:
        chartData !== undefined
          ? chartData["title"]
          : CHART_AXIS_FALLBACK["title"],
      align: "left",
    },
    dataLabels: {
      style: {
        fontSize: "8px",
      },
    },
    legend: {
      show: false,
    },
    fill: {
      colors: colorList.length > 0 ? colorList : [chartColor],
      opacity: 0.9,
    },
    colors: colorList.length > 0 ? colorList : [chartColor],
    xaxis: {
      categories:
        chartData !== undefined ? chartData["xaxis"]["data"] : undefined,
      labels: {
        style: {
          fontSize: "8px",
        },
        rotate: -90,
      },
      title: {
        text:
          chartData !== undefined
            ? humanize(chartData["xaxis"]["name"])
            : CHART_AXIS_FALLBACK["x"],
      },
    },
    tooltip: {
      y: {
        title: {
          formatter: function (seriesName) {
            return humanize(seriesName);
          },
        },
      },
    },
    yaxis: fYData,
  };

  const series: any =
    chartData !== undefined && Array.isArray(chartData["yaxis"]) === true
      ? chartData["yaxis"]
      : undefined;

  return (
    <div className="my-2 chartWrp border-1 rounded-lg w-full p-2">
      {series !== undefined &&
      option.xaxis?.categories !== undefined &&
      chartData["ytitle"] !== undefined ? (
        <ApexChart
          type="line"
          options={option}
          series={series}
          height={chartHeight}
          width={"100%"}
          key={dataKey}
        />
      ) : (
        <ChartFallBack />
      )}
    </div>
  );
}
